import React from "react";
import AboutUsHero from "./AboutUsSections/AboutUsHero";
import Empower from "./AboutUsSections/Empower";
import Mission from "./AboutUsSections/Mission";
import Authenticity from "./AboutUsSections/Authenticity";
import Vision from "./AboutUsSections/Vision";
import Stories from "./AboutUsSections/Stories";
import Footer from "../components/Footer";
import ProductCaseStudySection from "./ProductSections/ProductCaseStudy";

const AboutUs: React.FC = () => {
  return (
    <div className="contact-us-container">
      <section>
        <AboutUsHero />
      </section>

      <section>
        <Empower />
      </section>

      <section>
        <Mission />
      </section>

      <section>
        <Authenticity />
      </section>

      <section>
        <Vision />
      </section>

      <section id="stories-section">
        <Stories />
      </section>

      {/* <section>
        <ProductCaseStudySection />
      </section> */}

      <section style={{ marginTop: "80px" }}>
        <Footer />
      </section>
    </div>
  );
};

export default AboutUs;
